import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { ScoresService } from 'src/app/service/scores.service';
import { AcademicsService } from 'src/app/service/academics.service';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { DatePipe } from '@angular/common'
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-course-assessment-units-update',
  templateUrl: './course-assessment-units-update.component.html',
  styleUrls: ['./course-assessment-units-update.component.scss']
})
export class CourseAssessmentUnitsUpdateComponent implements OnInit {
  showLoader: boolean = false;
  updating: boolean = false;
  roles: any = [];
  assUnits: any = [];
  coursesData: any;
  courses: any = [];
  CourseSelectedPreRequisite: any;
  CourseSelectedCoRequisite: any;
  dropdownSettings: any = {};
  ShowFilter = true;
  courseAssUnitId: any;
  avaRoles: any;
  allIsps: any;

  updatecourseAssUnit = new FormGroup({
    subjectid: new FormControl('', [
      Validators.required,
    ]),
    asesid: new FormControl('', [
      Validators.required,
    ]),
    subjAsesNameAr: new FormControl('', [
      Validators.required,
    ]),
    subjAsesNameEn: new FormControl('', [
      Validators.required,
    ]),
    asesType: new FormControl('', [
      Validators.required,
    ]),
    orderNo: new FormControl('', [
      Validators.required,
      Validators.pattern("^[0-9]*$"),
    ]),
    totalScore: new FormControl('', [
      Validators.required,
      Validators.pattern("^[0-9]+\.?[0-9]*$"),
    ]),
    totalScorePercent: new FormControl('', [
      Validators.required,
      Validators.pattern("^[0-9]+\.?[0-9]*$"),
    ]),
    active: new FormControl('', [
      Validators.required,
    ]),

  });
  courseAssUnitData: any;
  batchId: any;
  orgid: any;
  yearId: any;
  semesterId: any;
  subjectId: any;

  constructor(
    // private userService: UserService,
    //  private ispService: IspService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private academicsService: AcademicsService
    , private roleService: RoleService
    , private orgService: OrgService
    , private datePipe: DatePipe
    , private scoresService: ScoresService
    , private coursesService: CoursesService
    , private enrollmentGroupService: EnrollmentGroupService
  ) {

  }

  // changeRole(e: any) {
  //   this.createType.value.roleType = e.target.value, {
  //     onlySelf: true
  //   }
  // }
  ngOnInit(): void {
    this.orgid = this.globals.currentUserInfo.orgid;
    this.showLoader = true;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.courseAssUnitId = params['courseAssUnitId'] || "";
        this.batchId = params['batchId'] || "";
        this.yearId = params['yearId'] || "";
        this.semesterId = params['semesterId'] || "";
        this.subjectId = params['subjectId'] || "";

        if (this.courseAssUnitId != "" && this.yearId != "" && this.semesterId != "" && this.batchId != "") {
          if (this.subjectId == "") {
            this.subjectId = 0;
          }
          this.getAssUnitsAndCourseAndAssUnitById();

        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.router.navigate(['/scores-grades/course-assessment-units'], { queryParams: { yearId: this.yearId, semesterId: this.semesterId, batchId: this.batchId, subjectId: this.subjectId } });
        }
      });
  }

  updatecourseAssUnitChange() {
  }

  updatecourseAssUnitSubmit() {
    if (this.updatecourseAssUnit.valid) {
      this.updateCourseAssUnit(this.updatecourseAssUnit.value);
    }
    else {
      this.updatecourseAssUnit.markAllAsTouched();
      this.updatecourseAssUnit.markAsDirty();
    }
  }

  updateCourseAssUnit(courseAssUnitObj: any) {
    this.updating = true;
    let username = this.globals.currentUserInfo.username;
    this.courseAssUnitData = Object.assign(this.courseAssUnitData, courseAssUnitObj);
    this.scoresService.updateCourseAssUnit(username, this.courseAssUnitId, 10, this.courseAssUnitData)
      .subscribe(
        data => {
          console.log(data);
          if (data.sts == "SUCCESS") {
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }

            this.router.navigate(['/scores-grades/course-assessment-units'], { queryParams: { yearId: this.yearId, semesterId: this.semesterId, batchId: this.batchId, subjectId: this.subjectId } });
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }
          }
          this.updating = false;
        },
        error => {
          this.updating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
        }
      );
  }

  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }
  changeactive() {

  }

  getAssUnitsAndCourseAndAssUnitById() {
    this.showLoader = true;
    let bulkApis = [
      this.scoresService.getAllAssesmentUnit(),
      // this.coursesService.getAllCourses(),
      this.enrollmentGroupService.getBatchSubjects(this.orgid, this.batchId),
      this.scoresService.getCourseAssUnitById(this.courseAssUnitId),
    ];

    forkJoin(bulkApis).subscribe(
      data => {
        // console.log(data);
        if (typeof data[0] != undefined)
          this.assUnits = data[0];

        if (typeof data[1] != undefined)
          this.courses = data[1];

        if (typeof data[2] != undefined) {
          this.courseAssUnitData = data[2];
          this.updatecourseAssUnit.patchValue(this.courseAssUnitData);
        }

        this.showLoader = false;
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
        this.showLoader = false;
      }
    );
  }

}
